import { useMemo } from 'react';
import { ReactComponent as LinkIcon } from '@elementary/common-ui/assets/link.svg';
import { IconButton, Menu } from '@elementary/common-ui/components';
import { Option } from '@elementary/common-ui/components/Menu/Menu';
import useCopyTestLink from '@elementary/common-ui/hooks/useCopyTestLink';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import useSnackbar from '@/shared/hooks/useSnackbar';

type Props = {
  elementaryUniqueId: string;
};

const AdditionalActionsButton = ({ elementaryUniqueId }: Props) => {
  const { openSnackbar } = useSnackbar();
  const copyLink = useCopyTestLink(elementaryUniqueId, (message) =>
    openSnackbar({ message }),
  );

  const items = useMemo(() => {
    const value: Option[] = [
      {
        value: 'copy',
        label: 'Copy link',
        icon: <LinkIcon />,
      },
    ];
    return value;
  }, []);

  return (
    <Menu
      menuTitle="ADDITIONAL ACTIONS"
      menuButton={
        <IconButton sx={{ p: '0 8px !important' }}>
          <MoreHorizIcon />
        </IconButton>
      }
      options={items}
      onChange={() => copyLink()}
    />
  );
};

export default AdditionalActionsButton;
